import { ListPageType } from '../../assets/enums/list-page-type.ts';

// export const iconsMap = {
//   [ListPageType.partners]: <EmptyListWithoutFiltersIcon />,
//   [ListPageType.courses]: <EmptyCoursesListIcon />,
//   [ListPageType.devices]: 'null',
//   [ListPageType.gameplay]: 'null',
//   [ListPageType.players]: 'null',
//   [ListPageType.users]: 'null',
// };

const baseNoItemsLabel = (entityName: string) => `No ${entityName} have been added yet`;

export const noItemsLabelsMap = {
  [ListPageType.partners]: baseNoItemsLabel('Partners'),
  [ListPageType.courses]: baseNoItemsLabel('Courses'),
  [ListPageType.devices]: baseNoItemsLabel('Devices'),
  [ListPageType.gameplay]: baseNoItemsLabel('Games'),
  [ListPageType.players]: baseNoItemsLabel('Players'),
  [ListPageType.users]: baseNoItemsLabel('Users'),
  [ListPageType.partnerCourses]: baseNoItemsLabel('Courses'),
};

const baseNoItemsBySearchParamsLabel = (entityName: string) =>
  `No records of ${entityName} matching the filters were found`;

export const noItemsBySearchParamsLabelsMap = {
  [ListPageType.partners]: baseNoItemsBySearchParamsLabel('partners'),
  [ListPageType.courses]: baseNoItemsBySearchParamsLabel('courses'),
  [ListPageType.devices]: baseNoItemsBySearchParamsLabel('devices'),
  [ListPageType.gameplay]: baseNoItemsBySearchParamsLabel('games'),
  [ListPageType.players]: baseNoItemsBySearchParamsLabel('players'),
  [ListPageType.users]: baseNoItemsBySearchParamsLabel('users'),
  [ListPageType.partnerCourses]: baseNoItemsBySearchParamsLabel('courses'),
};

export const addButtonLabel = {
  [ListPageType.partners]: 'Add Partner',
  [ListPageType.courses]: 'Add Course',
  [ListPageType.devices]: 'Add Device',
  [ListPageType.gameplay]: 'Add Game',
  [ListPageType.players]: 'Add Player',
  [ListPageType.users]: 'Invite User',
  [ListPageType.partnerCourses]: 'Add Course',
};
